<ds-tabs>
  <ds-tabs-label for="termsOfUse">{{ 'imprint.termsOfUse.headline' | translate }}</ds-tabs-label>
  <ds-tabs-content id="termsOfUse">
    <div class="tab-content">
      <div class="title-md first-title">{{ "imprint.termsOfUse.preamble.header" | translate }}</div>
      <ol>
        <li>{{ "imprint.termsOfUse.preamble.text1" | translate }}</li>
        <li [innerHTML]="'imprint.termsOfUse.preamble.text2' | translate"></li>
        <li [innerHTML]="'imprint.termsOfUse.preamble.text3' | translate"></li>
      </ol>

      <div class="title-md">{{ "imprint.termsOfUse.purpose.header" | translate }}</div>
      <div>{{ "imprint.termsOfUse.purpose.text1" | translate }}</div>
      <div>{{ "imprint.termsOfUse.purpose.text2" | translate }}</div>
      <div>{{ "imprint.termsOfUse.purpose.text3" | translate }}</div>

      <div class="title-md">{{ "imprint.termsOfUse.obligations.header" | translate }}</div>
      <div>{{ "imprint.termsOfUse.obligations.text1" | translate }}</div>
      <div>{{ "imprint.termsOfUse.obligations.text2" | translate }}</div>
      <div>{{ "imprint.termsOfUse.obligations.text3" | translate }}</div>

      <div class="title-md">{{ "imprint.termsOfUse.requirements.header" | translate }}</div>
      <div>{{ "imprint.termsOfUse.requirements.text1" | translate }}</div>
    </div>
  </ds-tabs-content>

  <ds-tabs-label for="dataProtectionInformation">{{ 'imprint.dataProtectionInformation.headline' | translate }}
  </ds-tabs-label>
  <ds-tabs-content id="dataProtectionInformation">
    <div class="tab-content">
      <div class="title-md first-title">{{ "imprint.dataProtectionInformation.premises.header" | translate }}</div>
      <ol>
        <li>{{ "imprint.dataProtectionInformation.premises.text1" | translate }}</li>
        <li [innerHTML]="'imprint.dataProtectionInformation.premises.text2' | translate"></li>
        <li>{{ "imprint.dataProtectionInformation.premises.text3" | translate }}</li>
      </ol>

      <div class="title-md">{{ "imprint.dataProtectionInformation.notice.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.notice.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.notice.text2" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.notice.text3" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.responsibleEntity.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.responsibleEntity.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.responsibleEntity.text2" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.responsibleEntity.text3" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.responsibleEntity.text4" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.responsibleEntity.text5" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.whenPersonalData.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.whenPersonalData.text1" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.whenPersonalData.text2" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.whenPersonalData.text3" | translate }}</li>
      </ul>

      <div class="title-md">{{ "imprint.dataProtectionInformation.whatPersonalData.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.whatPersonalData.text1" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.whatPersonalData.text2" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.whatPersonalData.text3" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.whatPersonalData.text4" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.whatPersonalData.text5" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.whatPersonalData.text6" | translate }}</li>
      </ul>
      <div>{{ "imprint.dataProtectionInformation.whatPersonalData.text7" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.pseudonymousData.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.pseudonymousData.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.purposes.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposes.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposes.text2" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.purposeA.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeA.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeA.text2" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.purposeA.text3" | translate }}</li>
      </ul>
      <div>{{ "imprint.dataProtectionInformation.purposeA.text4" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeA.text5" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.purposeA.text6" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeA.text7" | translate }}</li>
      </ul>
      <div>{{ "imprint.dataProtectionInformation.purposeA.text8" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeA.text9" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.purposeB.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeB.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeB.text2" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.purposeC.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeC.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeC.text2" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeC.text3" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeC.text4" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.purposeC.text5" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeC.text6" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeC.text7" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeC.text8" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeC.text9" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeC.text10" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeC.text11" | translate }}</li>
      </ul>
      <div>{{ "imprint.dataProtectionInformation.purposeC.text12" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeC.text13" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.purposeD.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeD.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeD.text2" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeD.text3" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.purposeE.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeE.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeE.text2" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.purposeE.text3" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeE.text4" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeE.text5" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeE.text6" | translate }}</li>
      </ul>
      <div>{{ "imprint.dataProtectionInformation.purposeE.text7" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeE.text8" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.purposeF.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeF.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeF.text2" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeF.text3" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.purposeF.text4" | translate }}</li>
      </ul>

      <div class="title-md">{{ "imprint.dataProtectionInformation.purposeG.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeG.text1" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.purposeG.text2" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeG.text3" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.purposeG.text4" | translate }}</li>
      </ul>

      <div class="title-md">{{ "imprint.dataProtectionInformation.purposeH.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.purposeH.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.protection.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.protection.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.protection.text2" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.protection.text3" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.protection.text4" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.protection.text5" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.protection.text6" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.protection.text7" | translate }}</li>
      </ul>
      <div>{{ "imprint.dataProtectionInformation.protection.text8" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.authentication.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.authentication.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.retention.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.retention.text1" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.retention.text2" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.retention.text3" | translate }}</li>
      </ul>
      <div>{{ "imprint.dataProtectionInformation.retention.text4" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.retention.text5" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.retentionUseContract.header" | translate }}
      </div>
      <div>{{ "imprint.dataProtectionInformation.retentionUseContract.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.retentionUseContract.text2" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.retentionClaims.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.retentionClaims.text1" | translate }}</div>

      <div
        class="title-md">{{ "imprint.dataProtectionInformation.retentionCustomerService.header" | translate }}
      </div>
      <div>{{ "imprint.dataProtectionInformation.retentionCustomerService.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.internationalAccess.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.internationalAccess.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.internationalAccess.text2" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.internationalAccess.text3" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.internationalAccess.text4" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.contact.header" | translate }}</div>
      <div [innerHTML]="'imprint.dataProtectionInformation.contact.text1' | translate"></div>
      <div>{{ "imprint.dataProtectionInformation.contact.text2" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.contact.text3" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.contact.text4" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.contact.text5" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.contact.text6" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.contact.text7" | translate }}</li>
        <li [innerHTML]="'imprint.dataProtectionInformation.contact.text8' | translate"></li>
      </ul>
      <div>{{ "imprint.dataProtectionInformation.contact.text9" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.rights.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rights.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.rightAccess.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rightAccess.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rightAccess.text2" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.rightRectification.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rightRectification.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.rightErasure.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rightErasure.text1" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.rightErasure.text2" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.rightErasure.text3" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.rightErasure.text4" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.rightErasure.text5" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.rightErasure.text6" | translate }}</li>
      </ul>

      <div class="title-md">{{ "imprint.dataProtectionInformation.rightRestriction.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rightRestriction.text1" | translate }}</div>
      <ul>
        <li>{{ "imprint.dataProtectionInformation.rightRestriction.text2" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.rightRestriction.text3" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.rightRestriction.text4" | translate }}</li>
        <li>{{ "imprint.dataProtectionInformation.rightRestriction.text5" | translate }}</li>
      </ul>

      <div class="title-md">{{ "imprint.dataProtectionInformation.rightPortability.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rightPortability.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rightPortability.text2" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.rightObjection.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rightObjection.text1" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.rightObjection.text2" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.timelines.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.timelines.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.infoRestriction.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.infoRestriction.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.dataProtectionInformation.complaints.header" | translate }}</div>
      <div>{{ "imprint.dataProtectionInformation.complaints.text1" | translate }}</div>

    </div>
  </ds-tabs-content>

  <ds-tabs-label for="imprint">{{ 'imprint.imprint.headline' | translate }}</ds-tabs-label>
  <ds-tabs-content id="imprint">
    <div class="tab-content">
      <div class="title-md first-title">{{ "imprint.imprint.operator.header" | translate }}</div>
      <div>{{ "imprint.imprint.operator.text1" | translate }}</div>
      <div>{{ "imprint.imprint.operator.text2" | translate }}</div>
      <div [innerHTML]="'imprint.imprint.operator.text3' | translate"></div>
      <div>{{ "imprint.imprint.operator.text4" | translate }}</div>
      <div>{{ "imprint.imprint.operator.text5" | translate }}</div>
      <div>{{ "imprint.imprint.operator.text6" | translate }}</div>
      <div>{{ "imprint.imprint.operator.text7" | translate }}</div>
      <div>{{ "imprint.imprint.operator.text8" | translate }}</div>
      <div>{{ "imprint.imprint.operator.text9" | translate }}</div>

      <div class="title-md">{{ "imprint.imprint.trademark.header" | translate }}</div>
      <div>{{ "imprint.imprint.trademark.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.imprint.liability.header" | translate }}</div>
      <div>{{ "imprint.imprint.liability.text1" | translate }}</div>

      <div class="title-md">{{ "imprint.imprint.copyright.header" | translate }}</div>
      <div>{{ "imprint.imprint.copyright.text1" | translate }}</div>
      <div>{{ "imprint.imprint.copyright.text2" | translate }}</div>
      <div>{{ "imprint.imprint.copyright.text3" | translate }}</div>

      <div class="title-md">{{ "imprint.imprint.responsible.header" | translate }}</div>
      <div>{{ "imprint.imprint.responsible.text1" | translate }}</div>
      <div>{{ "imprint.imprint.responsible.text2" | translate }}</div>
      <div>{{ "imprint.imprint.responsible.text3" | translate }}</div>
      <div>{{ "imprint.imprint.responsible.text4" | translate }}</div>
    </div>
  </ds-tabs-content>
</ds-tabs>
